<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1200px] mx-auto">

    <!-- Header -->
    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div class="flex items-center gap-4 min-w-0">
        <a [routerLink]="['/labels']" [queryParams]="editing ? { selected: editing.id } : {}"
          class="h-10 w-10 flex-shrink-0 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-900 hover:border-amber-300 transition-colors"
          matTooltip="Back to labels" aria-label="Back to labels">
          <mat-icon>arrow_back</mat-icon>
        </a>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400">
            <a [routerLink]="['/labels']" class="hover:text-gray-700">Labels</a>
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span>{{ editing ? 'Edit' : 'New' }}</span>
          </div>
          <h1 class="text-2xl font-bold text-gray-900 tracking-tight truncate">{{ loading ? 'Loading…' : editing ? editing.title : (title.trim() || 'New label') }}</h1>
        </div>
      </div>
      <div class="flex items-center gap-2 flex-wrap">
      @if (editing) {
        <app-record-nav noun="label" listName="Labels" [position]="position" [total]="ordered.length"
          [prevName]="prev?.title ?? null" [nextName]="next?.title ?? null" [disabled]="saving" (prev)="goTo(prev)" (next)="goTo(next)"></app-record-nav>
      }
      @if (editing && canDelete) {
        <button type="button" class="flex items-center gap-1.5 px-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm font-semibold text-gray-600 hover:border-red-200 hover:bg-red-50 hover:text-red-600 transition-colors" (click)="remove()">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">delete</mat-icon> Delete
        </button>
      }
      </div>
    </div>

    @if (loading) {
      <div class="rounded-2xl bg-white border border-gray-100 py-24 flex flex-col items-center justify-center text-sm text-gray-500">
        <mat-spinner diameter="30"></mat-spinner><span class="mt-3">Loading&hellip;</span>
      </div>
    } @else if (notFound) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">search_off</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">That label doesn't exist</p>
        <a [routerLink]="['/labels']" class="mt-4 inline-block text-xs font-semibold text-amber-700 hover:underline">Back to labels</a>
      </div>
    } @else {

    @if (editing && editing.products) {
      <div class="mb-5 flex items-start gap-3 px-4 py-3 rounded-2xl bg-amber-50 border border-amber-200 text-amber-900">
        <mat-icon class="!text-[20px] !h-5 !w-5 flex-shrink-0">info</mat-icon>
        <p class="text-sm">On <strong>{{ editing.products | number }} product{{ editing.products === 1 ? '' : 's' }}</strong> - your changes show on all of them straight away.</p>
      </div>
    }

    <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] gap-6 items-start">

      <!-- ============ FORM ============ -->
      <section class="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
        <div class="flex items-center gap-3 mb-5">
          <span class="h-9 w-9 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center"><mat-icon class="!text-[19px] !h-[19px] !w-[19px]">sell</mat-icon></span>
          <div><h2 class="text-[15px] font-bold text-gray-900">Label</h2><p class="text-xs text-gray-500">Its name here, and what customers see on the product</p></div>
        </div>

        <div class="flex flex-col gap-5">
          <div>
            <div class="flex items-baseline justify-between">
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wide">Name</label>
              <span class="text-[11px] text-gray-400 tabular-nums">{{ title.length }} / 100</span>
            </div>
            <input type="text" maxlength="100" [ngModel]="title" (ngModelChange)="onTitle($event)" placeholder="e.g. Winter Clearance"
              class="mt-1 w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 text-[15px] font-semibold outline-none focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100" />
            <p class="mt-1.5 text-xs text-gray-400">Shown in the back office when picking labels. Names with <strong class="text-gray-600">Black Friday</strong> or <strong class="text-gray-600">FREE SEALER</strong> get their own style on the website.</p>
            @if (sameName) {
              <p class="mt-1.5 flex items-center gap-1 text-xs text-amber-700"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">info</mat-icon>Another label is already called "{{ sameName.title }}" (shows "{{ sameName.label }}")</p>
            }
          </div>

          <div>
            <div class="flex items-baseline justify-between">
              <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wide">Text on the product image</label>
              <span class="text-[11px] text-gray-400 tabular-nums">{{ text.length }} / 300</span>
            </div>
            <input type="text" maxlength="300" [ngModel]="text" (ngModelChange)="onText($event)" placeholder="e.g. WINTER CLEARANCE"
              class="mt-1 w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 text-[15px] font-bold tracking-wide outline-none focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100" />
            <p class="mt-1.5 text-xs text-gray-400">Keep it short - it sits in a bar across the bottom of the photo. Exactly <strong class="text-gray-600">BESTSELLER</strong> shows as a green corner badge instead.</p>
          </div>

          <div>
            <div class="text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2">Quick picks</div>
            <div class="flex flex-wrap gap-1.5">
              @for (s of suggestions; track s) {
                <button type="button" class="text-xs font-semibold px-2.5 py-1.5 rounded-lg border transition-colors"
                  [ngClass]="text === s ? 'border-amber-400 bg-amber-50 text-amber-900' : 'border-gray-200 bg-white text-gray-600 hover:border-amber-300 hover:bg-amber-50/50'" (click)="pick(s)">{{ s }}</button>
              }
            </div>
          </div>

          <!-- Colours -->
          <div class="pt-5 border-t border-gray-100">
            <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
              <div>
                <div class="text-[11px] font-semibold text-gray-500 uppercase tracking-wide">Colours</div>
                <p class="text-xs text-gray-400">Keep the website's own style, or pick your own</p>
              </div>
              <div class="flex bg-gray-100 rounded-xl p-1 gap-1">
                <button type="button" class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-all" [ngClass]="colourMode === 'BUILT_IN' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'" (click)="colourMode = 'BUILT_IN'">Built-in</button>
                <button type="button" class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-all" [ngClass]="colourMode === 'CUSTOM' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'" (click)="colourMode = 'CUSTOM'">Custom</button>
              </div>
            </div>

            @if (colourMode === 'BUILT_IN') {
              <div class="flex items-center gap-3 px-4 py-3 rounded-xl bg-gray-50 border border-gray-100 text-sm text-gray-600">
                <mat-icon class="!text-[18px] !h-[18px] !w-[18px] text-gray-400">palette</mat-icon>
                <span>Uses the <strong class="text-gray-800">{{ styleNames[style] }}</strong> style, picked from the name and text.</span>
              </div>
            } @else {
              <div class="flex flex-col gap-4">
                <div>
                  <div class="text-xs font-semibold text-gray-600 mb-2">Background</div>
                  <div class="flex flex-wrap items-center gap-2">
                    @for (c of palette; track c.hex) {
                      <button type="button" class="relative h-8 w-8 rounded-full ring-1 ring-black/10 transition-transform hover:scale-110 focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-200"
                        [style.background-color]="c.hex" [matTooltip]="c.name" [attr.aria-label]="c.name" (click)="setBg(c.hex)">
                        @if (bg.toLowerCase() === c.hex) {
                          <span class="absolute inset-0 flex items-center justify-center"><mat-icon class="!text-[16px] !h-4 !w-4" [style.color]="contrastOf(c.hex)">check</mat-icon></span>
                          <span class="absolute -inset-1 rounded-full ring-2 ring-amber-400"></span>
                        }
                      </button>
                    }
                    <label class="relative h-8 w-8 rounded-full cursor-pointer ring-1 ring-black/10 overflow-hidden bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)] hover:scale-110 transition-transform" matTooltip="Any colour">
                      <input type="color" class="absolute inset-0 opacity-0 cursor-pointer" [ngModel]="bg" (ngModelChange)="setBg($event)" aria-label="Pick any background colour" />
                    </label>
                    <div class="flex items-center gap-1.5 ml-1 pl-3 border-l border-gray-200">
                      <span class="h-6 w-6 rounded-md ring-1 ring-black/10" [style.background-color]="bg"></span>
                      <input type="text" maxlength="7" [ngModel]="bg" (ngModelChange)="onHex('bg', $event)" class="w-24 px-2 py-1.5 rounded-lg border border-gray-200 bg-gray-50 text-xs font-mono outline-none focus:bg-white focus:border-amber-400" aria-label="Background colour hex" />
                    </div>
                  </div>
                </div>

                <div>
                  <div class="text-xs font-semibold text-gray-600 mb-2">Text</div>
                  <div class="flex flex-wrap items-center gap-2">
                    <button type="button" class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-semibold transition-colors"
                      [ngClass]="textMode === 'AUTO' ? 'border-amber-400 bg-amber-50 text-amber-900' : 'border-gray-200 text-gray-600 hover:border-gray-300'" (click)="textMode = 'AUTO'">
                      <mat-icon class="!text-[14px] !h-3.5 !w-3.5">auto_awesome</mat-icon>Auto
                      <span class="h-3.5 w-3.5 rounded-full ring-1 ring-black/10" [style.background-color]="contrastOf(bg)"></span>
                    </button>
                    @for (c of [{ name: 'Black', hex: '#111111' }, { name: 'White', hex: '#ffffff' }]; track c.hex) {
                      <button type="button" class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-semibold transition-colors"
                        [ngClass]="textMode === 'CUSTOM' && fg === c.hex ? 'border-amber-400 bg-amber-50 text-amber-900' : 'border-gray-200 text-gray-600 hover:border-gray-300'" (click)="fg = c.hex; textMode = 'CUSTOM'">
                        <span class="h-3.5 w-3.5 rounded-full ring-1 ring-black/10" [style.background-color]="c.hex"></span>{{ c.name }}
                      </button>
                    }
                    <label class="relative flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-semibold cursor-pointer transition-colors"
                      [ngClass]="textMode === 'CUSTOM' && fg !== '#111111' && fg !== '#ffffff' ? 'border-amber-400 bg-amber-50 text-amber-900' : 'border-gray-200 text-gray-600 hover:border-gray-300'">
                      <span class="h-3.5 w-3.5 rounded-full ring-1 ring-black/10 bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]"></span>Other
                      <input type="color" class="absolute inset-0 opacity-0 cursor-pointer" [ngModel]="effectiveFg" (ngModelChange)="fg = $event; textMode = 'CUSTOM'" aria-label="Pick any text colour" />
                    </label>
                    <input type="text" maxlength="7" [ngModel]="effectiveFg" (ngModelChange)="onHex('fg', $event)" class="w-24 px-2 py-1.5 rounded-lg border border-gray-200 bg-gray-50 text-xs font-mono outline-none focus:bg-white focus:border-amber-400" aria-label="Text colour hex" />
                  </div>
                </div>

                <!-- Sample bar at full width -->
                <div class="rounded-lg py-2 text-center text-xs font-bold tracking-wide shadow-sm" [style.background-color]="bg" [style.color]="effectiveFg">{{ text.trim() || 'YOUR LABEL' }}</div>
              </div>
            }
          </div>
        </div>
      </section>

      <!-- ============ SIDE ============ -->
      <div class="flex flex-col gap-5 lg:sticky lg:top-4">
        <section class="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div class="px-5 py-3 border-b border-gray-100 flex items-center justify-between">
            <span class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-400"><mat-icon class="!text-[16px] !h-4 !w-4">visibility</mat-icon> Preview</span>
            <span class="text-[11px] font-semibold text-gray-500">{{ colourMode === 'CUSTOM' ? 'Custom colours' : styleNames[style] }}</span>
          </div>
          <div class="p-5">
            <div class="mx-auto max-w-[240px]">
              <app-label-preview [title]="title" [text]="text.trim()" [bg]="savedBg" [fg]="savedFg" size="lg"></app-label-preview>
              <div class="mt-3 h-3 w-3/4 mx-auto rounded bg-gray-100"></div>
              <div class="mt-1.5 h-3 w-1/2 mx-auto rounded bg-gray-100"></div>
            </div>
            <p class="mt-4 text-center text-[11px] text-gray-400">How it looks on a product in the shop</p>
          </div>
        </section>

        @if (editing) {
        <section class="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div class="px-5 py-3 border-b border-gray-100 flex items-center justify-between">
            <span class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-gray-400"><mat-icon class="!text-[16px] !h-4 !w-4">inventory_2</mat-icon> Products with it</span>
            <span class="text-xs font-semibold text-gray-500 tabular-nums">{{ editing.products | number }}</span>
          </div>
          @if (productsLoading) {
            <div class="py-8 flex justify-center"><mat-spinner diameter="22"></mat-spinner></div>
          } @else if (!products.length) {
            <div class="px-5 py-8 text-center text-sm text-gray-400">Not on any product yet</div>
          } @else {
            <div class="max-h-[300px] overflow-y-auto p-2">
              @for (p of products; track p.productId) {
              <a class="group flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-amber-50/70" [routerLink]="['/products/edit', p.productSlug]" target="_blank" rel="noopener">
                <span class="min-w-0 flex-1 text-sm text-gray-800 truncate">{{ p.productName }}</span>
                @if (!p.active) { <span class="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-gray-100 text-gray-500">Inactive</span> }
                <mat-icon class="!text-[15px] !h-[15px] !w-[15px] text-gray-300 group-hover:text-amber-600">open_in_new</mat-icon>
              </a>
              }
            </div>
          }
        </section>
        }
      </div>
    </div>

    <!-- Save bar -->
    <div class="sticky bottom-4 z-20 mt-6 flex flex-wrap items-center justify-between gap-3 bg-white/95 backdrop-blur rounded-2xl border border-gray-200 shadow-lg px-5 py-3">
      <div class="min-w-0 text-sm">
        @if (formError) {
          <span class="flex items-center gap-1.5 text-red-600"><mat-icon class="!text-[16px] !h-4 !w-4 flex-shrink-0">error_outline</mat-icon><span class="truncate">{{ formError }}</span></span>
        } @else if (editing && !dirty) {
          <span class="text-gray-400">No changes yet</span>
        } @else {
          <span class="flex items-center gap-1.5 text-emerald-600"><mat-icon class="!text-[16px] !h-4 !w-4">check_circle</mat-icon>Ready to save</span>
        }
      </div>
      <div class="flex items-center gap-2 ml-auto">
        <a [routerLink]="['/labels']" [queryParams]="editing ? { selected: editing.id } : {}" class="px-5 py-2.5 rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-100 transition-colors">Cancel</a>
        <button type="button" [disabled]="!!formError || saving || (editing && !dirty)" (click)="save()"
          class="flex items-center gap-1.5 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 text-sm font-bold shadow-sm hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-40 disabled:pointer-events-none">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">{{ saving ? 'hourglass_empty' : 'save' }}</mat-icon>
          {{ saving ? 'Saving…' : editing ? 'Save changes' : 'Create label' }}
        </button>
      </div>
    </div>
    }
  </div>
  </div>
</app-main-layout>
